import {
  AuthorHeroProps,
  AuthorHeroPropsWithSEO,
} from "~/components/AuthorHero";
import { Author, AuthorDetails } from "~/types/asgard/Author";
import { heDecodeOrDefault } from "./html-utils";

export const apiAuthorToProps = ({
  author_bio,
  author_thumbnail,
  author_title,
  author_email,
  display_name,
}: Author): AuthorHeroProps => ({
  authorBioHTML: heDecodeOrDefault(author_bio),
  authorName: heDecodeOrDefault(display_name),
  authorTitle: heDecodeOrDefault(author_title),
  authorEmail: heDecodeOrDefault(author_email),
  headshotImageUrl: author_thumbnail?.sizes?.full.source_url || null,
});

export const apiAuthorDetailsToProps = ({
  author_bio,
  author_thumbnail,
  author_title,
  author_email,
  display_name,
  seo,
  structuredData,
}: AuthorDetails): AuthorHeroPropsWithSEO => ({
  authorBioHTML: heDecodeOrDefault(author_bio),
  authorName: heDecodeOrDefault(display_name),
  authorTitle: heDecodeOrDefault(author_title),
  authorEmail: heDecodeOrDefault(author_email),
  headshotImageUrl: author_thumbnail?.sizes?.full.source_url || null,
  seo,
  structuredData,
});
